import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { createAction, createFeatureSelector, createReducer, createSelector, on, props } from '@ngrx/store';
import { catchError, map, of, switchMap } from 'rxjs';
import { CalendarioEdicaoPublicadaOutputDto } from 'src/app/domain/DTOs/output/publicacao/edicao-publicada-portal-output.dto';
import { EdicaoPublicadaService } from 'src/app/services/edicao-publicada.service';

const actionName = '[Obter Calendário Edições Publicadas]';

export const obterCalendarioEdicoesPublicadas = createAction(`${actionName} Obter`, props<{ ano: number; mes: number }>());
export const obterCalendarioEdicoesPublicadasSuccess = createAction(`${actionName} Sucesso`, props<{ response: CalendarioEdicaoPublicadaOutputDto[] }>());
export const obterCalendarioEdicoesPublicadasFailure = createAction(`${actionName} Falha`, props<{ erro: string }>());
export const obterCalendarioEdicoesPublicadasFinish = createAction(`${actionName} Concluir`);

export interface ObterCalendarioEdicoesPublicadasState {
  response: CalendarioEdicaoPublicadaOutputDto[];
  error: string | null;
}

const initialState: ObterCalendarioEdicoesPublicadasState = { response: [], error: null };

// -- Reducer
export const obterCalendarioEdicoesPublicadasReducer = createReducer(
  initialState,
  on(obterCalendarioEdicoesPublicadas, state => ({ ...state, error: null })),
  on(obterCalendarioEdicoesPublicadasSuccess, (state, { response }) => ({ ...state, response, error: null })),
  on(obterCalendarioEdicoesPublicadasFailure, (state, { erro }) => ({ ...state, response: [], error: erro })),
  on(obterCalendarioEdicoesPublicadasFinish, () => initialState)
);

// -- Selector
export const selectObterCalendarioEdicoesPublicadasState = createFeatureSelector<ObterCalendarioEdicoesPublicadasState>('obterCalendarioEdicoesPublicadas');
export const selectDadosObterCalendarioEdicoesPublicadas = createSelector(selectObterCalendarioEdicoesPublicadasState, state => state.response);
export const selectErrosObterCalendarioEdicoesPublicadas = createSelector(selectObterCalendarioEdicoesPublicadasState, state => state.error);

// -- Effect
@Injectable()
export class ObterCalendarioEdicoesPublicadasEffects {
  obterCalendarioEdicoesPublicadas$ = createEffect(() => this.actions$.pipe(
    ofType(obterCalendarioEdicoesPublicadas),
    switchMap(({ ano, mes }) => this.edicaoPublicadaService.obterCalendario(ano, mes).pipe(
      map(response => response.erros?.length
        ? obterCalendarioEdicoesPublicadasFailure({ erro: response.erros[0] })
        : obterCalendarioEdicoesPublicadasSuccess({ response: response.dados ?? [] })),
      catchError(() => of(obterCalendarioEdicoesPublicadasSuccess({ response: [] })))
    ))
  ));

  constructor(private readonly actions$: Actions, private readonly edicaoPublicadaService: EdicaoPublicadaService) {}
}
